import { StytchB2BProvider } from '@stytch/react/b2b';
import { StytchB2BHeadlessClient } from '@stytch/vanilla-js/dist/b2b/index.headless';
import React from 'react';

import type { ContainerComponent } from '../../common/types/Common';
import { STYTCH_PUBLIC_TOKEN } from '../../config/config';

export const stytchClient = new StytchB2BHeadlessClient(STYTCH_PUBLIC_TOKEN, {
    cookieOptions: {
        // Rename these to avoid conflicts with cookies from member app
        opaqueTokenCookieName: 'grove_stytch_session',
        jwtCookieName: 'grove_stytch_session_jwt',
    },
});

const AuthProvider: ContainerComponent = ({ children }) => {
    return (
        <StytchB2BProvider stytch={stytchClient}>{children}</StytchB2BProvider>
    );
};

export default AuthProvider;
